import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { SAL2020_R01DetailDto, SAL2020_R01Dto, SAL2020_R01HeaderDto } from './Dto_SAL2020_R01';
import { SAL2020_R01Filter } from "./Store_SAL2020_R01";

const baseUrl = `${config.apiUrl}/SAL2020_R01`;

const getParams = (filter: Partial<SAL2020_R01Filter>, listLength?: number) => {	
	return {
		compCd: filter.compCd || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,	

		listLength: listLength || 0
	}
}

export const getSAL2020_R01List = async (option: string, params: Partial<SAL2020_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<SAL2020_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getSAL2020_R01AllCount = async (params: Partial<SAL2020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getSAL2020_R01One = async (salBilNo: string) => {
	const url = `${baseUrl}/one/${salBilNo}`;

	return await getData<ResponseDto<SAL2020_R01HeaderDto>>(url);
}

export const getSAL2020_R01DetailList = async (salBilNo: string) => {
	const url = `${baseUrl}/detail/${salBilNo}`;

	return await getData<ResponseDto<SAL2020_R01DetailDto[]>>(url);
}

export const postSAL2020_R01 = async (data: SAL2020_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<SAL2020_R01Dto, ResponseDto<SAL2020_R01Dto[]>>(url, data);
}

export const patchSAL2020_R01 = async (data: SAL2020_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<SAL2020_R01Dto, ResponseDto<SAL2020_R01Dto[]>>(url, data);
}

export const deleteSAL2020_R01 = async (salesBillNumber: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			salesBillNumber
		}
	});
}

// export const printSAL2020_R01 = async (salBillNo: string) => {
// 	const url = `${baseUrl}/print`;

// 	return await getData<ResponseDto<string>>(url, {
// 		params: {
// 			salBillNo
// 		}
// 	})
// }

export const downloadExcel_SAL2020_R01 = async (option: string, salBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			salBillNo
		}
	})
}
/** 매출전표 PDF Blob 반환 (출력은 Content에서 QZ/브라우저 폴백 처리) */
export const getPdfBlob_SAL2020_R01 = async (salBillNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { salBillNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};